import { queryHomeSkin, queryNewHomeSkin } from "@/api/decorate";
import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { useCommonContext } from "../context/common";

const useSkin = () => {
  const { setSkin, activityTagNo } = useCommonContext();
  const [initNo, setInitNo] = useState<string>("");
  const [searchParams] = useSearchParams();

  // 查老皮肤接口
  const getSkinInfo = async () => {
    const res = await queryHomeSkin();
    setSkin((prev: any) => ({ ...(prev || {}), ...(res || {}) }));
  };

  // 查新皮肤接口
  const getNewSkinInfo = async (version: string) => {
    let params = {} as any;
    if (version) {
      params.skinVersion = version;
    }
    let res = await queryNewHomeSkin(params);
    if (res) {
      res.hasNewSkin = res?.categorySkinVOList?.some(
        (item: any) => item.categoryCode === activityTagNo,
      );
    }
    setSkin((prev: any) => ({ ...(prev || {}), ...(res || {}) }));
  };

  useEffect(() => {
    if (!initNo && activityTagNo) {
      const skinVersion = searchParams.get("skinVersion") || "";
      getNewSkinInfo(skinVersion).finally(getSkinInfo);
      setInitNo(activityTagNo);
    }
  }, [activityTagNo]);
};

export default useSkin;
